import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { NumericFormat } from "react-number-format";
import { DataGrid } from "@mui/x-data-grid";
import { useAppDispatch, useAppSelector } from "../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { mappingProductHistoryBuyList, mappingProductHistoryList, mappingProductHistoryPrimary, mappingProductHistorySaleList } from "utils/HelperProductHistory";
import { getProductPriceById } from "../redux/handlers/logic/getProductPriceById.handler";
import { NumberFormat } from "utils/HelperFunction";
import CustomNoRowsOverlay from "./CustomNoRowsOverlay";
export function ProductHistory(param) {
    var historyProduct = param.historyProduct, setModalProductHistory = param.setModalProductHistory;
    var _useState = _sliced_to_array(useState([]), 2), historyBuy = _useState[0], setHistoryBuy = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), historySale = _useState1[0], setHistorySale = _useState1[1];
    var _useState2 = _sliced_to_array(useState(), 2), historyPrimaryData = _useState2[0], setHistoryPrimaryData = _useState2[1];
    var _useState3 = _sliced_to_array(useState(1), 2), tab = _useState3[0], setTab = _useState3[1];
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var getProductPriceByIdReducer = useAppSelector(function(state) {
        return state.getProductPriceByIdReducer;
    });
    var getHistoryData = function(productPriceID) {
        dispatch(getProductPriceById(productPriceID, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    useEffect(function() {
        if (historyProduct && historyProduct[0]) {
            getHistoryData(historyProduct[0].productID);
        }
    }, [
        historyProduct
    ]);
    useEffect(function() {
        setIsLoading(getProductPriceByIdReducer.isFetching);
        if (getProductPriceByIdReducer.data) {
            var data = getProductPriceByIdReducer.data.data;
            var mappingHistoryPrimaryData = mappingProductHistoryPrimary(data);
            var mappingHistoryBuyList = mappingProductHistoryBuyList(data.dimNewGrItem);
            var mappingHistorySaleList = mappingProductHistorySaleList(data.saleHistory);
            setHistoryPrimaryData(mappingHistoryPrimaryData);
            setHistoryBuy(mappingHistoryBuyList);
            setHistorySale(mappingHistorySaleList);
        }
    }, [
        getProductPriceByIdReducer
    ]);
    var columnsd = [
        {
            field: "documentCode",
            headerName: "เลขที่เอกสาร",
            width: 160,
            sortable: false
        },
        {
            field: "distributor",
            headerName: "ผู้จัดจำหน่าย",
            width: 260,
            sortable: false
        },
        {
            field: "orderDate",
            headerName: "วันที่สั่งซื้อ",
            width: 200,
            sortable: false
        },
        {
            field: "barcode",
            headerName: "บาร์โค้ด",
            width: 150,
            sortable: false
        },
        {
            field: "ratioUnit",
            headerName: "หน่วย",
            width: 150,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsxs("div", {
                    className: "text-center",
                    children: [
                        row.productUnit,
                        /*#__PURE__*/ _jsx("br", {}),
                        "1X",
                        row.productRatioUnit
                    ]
                });
            }
        },
        {
            field: "quantity",
            headerName: "จำนวน",
            width: 150,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    className: "text-[#FF0000]",
                    children: row.quantity
                });
            }
        },
        {
            field: "pricePerUnit",
            headerName: "ราคาต่อหน่วย",
            cellClassName: "d-flex justify-content-end",
            width: 130,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    className: "pe-3",
                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                        displayType: "text",
                        thousandSeparator: ",",
                        decimalScale: 2,
                        fixedDecimalScale: true,
                        value: row.pricePerUnit
                    })
                });
            }
        },
        {
            field: "discountPerUnit",
            headerName: "ส่วนลดต่อหน่วย",
            cellClassName: "d-flex justify-content-end",
            width: 130,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    className: "pe-3",
                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                        displayType: "text",
                        thousandSeparator: ",",
                        decimalScale: 2,
                        fixedDecimalScale: true,
                        value: row.discountPerUnit
                    })
                });
            }
        },
        {
            field: "total",
            headerName: "ยอดรวม",
            cellClassName: "d-flex justify-content-end",
            headerClassName: "text-end",
            width: 130,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    className: "pe-3",
                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                        displayType: "text",
                        thousandSeparator: ",",
                        decimalScale: 2,
                        fixedDecimalScale: true,
                        value: row.total
                    })
                });
            }
        }
    ];
    return /*#__PURE__*/ _jsxs("div", {
        className: "  ",
        children: [
            historyPrimaryData ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex gap-[32px]",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "text-[22px] font-bold text-[#545454] mb-4",
                                children: [
                                    "ชื่อสินค้า : ",
                                    historyPrimaryData.productName,
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "text-[22px] font-bold text-[#545454] mb-4",
                                children: [
                                    "UMS : ",
                                    historyPrimaryData.umsName,
                                    " (",
                                    " ",
                                    /*#__PURE__*/ _jsxs("span", {
                                        className: "text-[#FF6B00]",
                                        children: [
                                            "1 X ",
                                            historyPrimaryData.umsRatio
                                        ]
                                    }),
                                    " ",
                                    ")",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "text-[22px] font-bold text-[#545454] mb-4",
                                children: [
                                    "UML : ",
                                    historyPrimaryData.umlName,
                                    " (",
                                    " ",
                                    /*#__PURE__*/ _jsxs("span", {
                                        className: "text-[#FF6B00]",
                                        children: [
                                            "1 X ",
                                            historyPrimaryData.umlRatio
                                        ]
                                    }),
                                    " ",
                                    ")",
                                    " "
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mb-4",
                        children: [
                            /*#__PURE__*/ _jsx("button", {
                                type: "button",
                                className: "btn btn-st-3 me-3 text-[16px]",
                                style: tab != 1 ? {
                                    background: "transparent",
                                    border: 0,
                                    color: "#9C9C9C"
                                } : {},
                                onClick: function() {
                                    return setTab(1);
                                },
                                children: "ประวัติการซื้อ"
                            }),
                            /*#__PURE__*/ _jsx("button", {
                                type: "button",
                                className: "btn btn-st-3 text-[16px]",
                                style: tab != 2 ? {
                                    background: "transparent",
                                    border: 0,
                                    color: "#9C9C9C"
                                } : {},
                                onClick: function() {
                                    return setTab(2);
                                },
                                children: "ประวัติการขาย"
                            })
                        ]
                    }),
                    tab == 1 ? /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsx(DataGrid, {
                            getRowId: function(row) {
                                return row.id;
                            },
                            getRowHeight: function() {
                                return "auto";
                            },
                            rows: historyBuy,
                            columns: columnsd,
                            // autoHeight={true}
                            initialState: {
                                pagination: {
                                    paginationModel: {
                                        pageSize: 10
                                    }
                                }
                            },
                            pageSizeOptions: [
                                10,
                                20,
                                30
                            ],
                            checkboxSelection: true,
                            disableRowSelectionOnClick: true,
                            slotProps: {
                                pagination: {
                                    labelRowsPerPage: "จำนวนรายการต่อหน้า"
                                }
                            },
                            sx: {
                                fontFamily: "Sarabun",
                                fontSize: "18px",
                                ".MuiDataGrid-columnHeaderTitle": {
                                    fontFamily: "Sarabun",
                                    fontSize: "18px"
                                }
                            }
                        })
                    }) : /*#__PURE__*/ _jsx("div", {
                        className: "d-flex justify-content-center",
                        children: /*#__PURE__*/ _jsxs("table", {
                            className: "table table-bordered text-center max-w-[600px]",
                            children: [
                                /*#__PURE__*/ _jsx("thead", {
                                    className: "",
                                    children: /*#__PURE__*/ _jsxs("tr", {
                                        style: {
                                            height: "50px"
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx("th", {
                                                className: "bg-[#F5F5F7]",
                                                children: "เดือน"
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                className: "bg-[#F5F5F7]",
                                                children: "จำนวนขายรวมทุกสาขา (ชิ้น)"
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                className: "bg-[#F5F5F7]",
                                                children: "อัตราเติบโต"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("tbody", {
                                    children: historySale.map(function(v, i) {
                                        return /*#__PURE__*/ _jsxs("tr", {
                                            style: {
                                                height: "50px"
                                            },
                                            children: [
                                                /*#__PURE__*/ _jsx("td", {
                                                    valign: "middle",
                                                    children: v.monthName
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    valign: "middle",
                                                    children: NumberFormat(v.sumQty, 0)
                                                }),
                                                /*#__PURE__*/ _jsxs("td", {
                                                    className: "".concat(v.ratePercent > 0 ? "!text-[#2DC76D]" : v.ratePercent < 0 ? "!text-[#FF0000]" : ""),
                                                    valign: "middle",
                                                    children: [
                                                        v.ratePercent,
                                                        " %"
                                                    ]
                                                })
                                            ]
                                        }, i);
                                    })
                                })
                            ]
                        })
                    })
                ]
            }) : "",
            /*#__PURE__*/ _jsx("div", {
                className: "text-right mt-5",
                children: /*#__PURE__*/ _jsx("button", {
                    type: "button",
                    className: "btn btn-st-3 me-3 text-[16px]",
                    onClick: function() {
                        return setModalProductHistory(function(prev) {
                            return _object_spread_props(_object_spread({}, prev), {
                                open: false
                            });
                        });
                    },
                    children: "ปิด"
                })
            })
        ]
    });
}
